export default "__VITE_ASSET__D4CY1IhZ__"